import Link from 'next/link';
import { FaGithub } from 'react-icons/fa';

import styles from './style.module.scss';

type Props = {
  name: string;
  githubAccount?: string | null | undefined;
};

export const MemberItem = ({ name, githubAccount }: Props) => (
  <div className={styles.memberItemWrapper}>
    <img
      alt={`${name}のアバター`}
      className={styles.memberItemIcon}
      src={
        githubAccount
          ? `https://avatars.githubusercontent.com/${githubAccount}`
          : '/images/user_default_icon.png'
      }
    />
    <div>
      <h4>{name}</h4>
      <Link
        legacyBehavior
        passHref
        href={`https://github.com/${githubAccount}`}
      >
        <a className={styles.memberGitHubLink} rel="noopener" target="_blank">
          <FaGithub color="black" size={15} />
          <span>{githubAccount}</span>
        </a>
      </Link>
    </div>
  </div>
);
